exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services-list-page.mobile .header-filter-components[data-v-232b5956]{margin:0}.services-list-page .cols-cards-info[data-v-232b5956]{margin-top:10px}", ""]);

// exports
